import React from 'react';

const EmailToolbar = ({ onSearch, searchTerm, onRefresh, selectedEmail, onDelete }) => {
  return (
    <div className="email-toolbar">
      <div className="toolbar-left">
        <button className="toolbar-action" onClick={onRefresh} title="Atualizar">
          <i className="fas fa-sync-alt"></i>
        </button>
        
        <div className="toolbar-divider"></div>
        
        <button className="toolbar-action" title="Selecionar">
          <i className="fas fa-square"></i>
        </button>
        
        {selectedEmail && (
          <>
            <button className="toolbar-action" title="Arquivar">
              <i className="fas fa-archive"></i>
            </button>
            
            <button className="toolbar-action" title="Marcar como spam">
              <i className="fas fa-exclamation-circle"></i>
            </button>
            
            <button className="toolbar-action" onClick={onDelete} title="Excluir">
              <i className="fas fa-trash"></i>
            </button>
            
            <div className="toolbar-divider"></div>
            
            <button className="toolbar-action" title="Marcar como não lido">
              <i className="fas fa-envelope"></i>
            </button>
            
            <button className="toolbar-action" title="Adiar">
              <i className="fas fa-clock"></i>
            </button>
            
            <button className="toolbar-action" title="Adicionar a tarefas">
              <i className="fas fa-tasks"></i>
            </button>
            
            <div className="toolbar-divider"></div>
            
            <button className="toolbar-action" title="Mover para">
              <i className="fas fa-folder"></i>
            </button>
            
            <button className="toolbar-action" title="Marcadores">
              <i className="fas fa-tag"></i>
            </button>
          </>
        )}
        
        <button className="toolbar-action" title="Mais">
          <i className="fas fa-ellipsis-v"></i>
        </button>
      </div>
      
      <div className="toolbar-right">
        <div className="search-box">
          <i className="fas fa-search search-icon"></i>
          <input
            type="text"
            placeholder="Pesquisar email"
            value={searchTerm}
            onChange={(e) => onSearch(e.target.value)}
            className="search-input"
          />
          <button className="search-filter" title="Mostrar opções de pesquisa">
            <i className="fas fa-sliders-h"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailToolbar;